module.exports = __webpack_public_path__ + "img/invite_bg@2x.73d64cb6.png";